// extracted by mini-css-extract-plugin
export default {"cls1":"VeloStepperContent-Content_cls1__u7t7k","cls2":"VeloStepperContent-Content_cls2__048tb VeloStepperContent-Content_cls1__u7t7k","form":"VeloStepperContent-Content_form__2bN+U"};